<template>
	<div id="app">
		<header-app></header-app>
		<router-view/>
		<footer-app></footer-app>
	</div>
</template>

<script>
import Header from './components/Header'
import Footer from './components/Footer'

export default {
	components: {
		headerApp: Header,
		footerApp: Footer
	}
}
</script>

<style>
	/* @import url('https://fonts.googleapis.com/css?family=Lato&display=swap'); */
	/* @import url('https://fonts.googleapis.com/css?family=Open+Sans&display=swap'); */
	/* @import url('https://fonts.googleapis.com/css?family=Ubuntu&display=swap'); */
	/* @import url('https://fonts.googleapis.com/css?family=Nunito&display=swap'); */

	@font-face {
		font-family: 'Nunito';
		src: url('./assets/fonts/Nunito/Nunito-Regular.ttf');
	}

	* {
		box-sizing: border-box;
	}

	body {
		margin: 0;
		padding: 0;
		font-family: 'Nunito';
	}

	.effect__fade {
		opacity: 0.0;
		transition: all 1.5s ease-out;
	}

	.effect__fade.down {
		transform: translateY(-1.5rem);
	}

	.effect__fade.up {
		transform: translateY(1.5rem);
	}

	.effect__fade.inview {
		transform: translateX(0rem);
		opacity: 1;
	}

	.separator {
		min-height: 20vh;
		background-color: #ffffff;
	}

	.separator--grey {
		min-height: 20vh;
		background-color: #f3f3f3;
	}

	.seprator__content {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding: 2rem 2rem;
	}

	.seprator__content p {
		text-align: justify;
	}

	.section-triangle {
		position: absolute;
		top: 0;
		width: 0;
		height: 0;
		border-left: 6rem solid transparent;
		border-right: 6rem solid transparent;
		border-top-width: 6rem;
		border-top-style: solid;
		border-top-color: #ffffff;
		transition: border 0.5s ease-in-out;
		z-index: 9;
    }

	.section-triangle--grey {
		border-top-color: #f3f3f3;
	}

	@media (min-width: 75rem) {
		body {
			font-size: 1.2rem;
		}
	}

	@media (min-width: 95rem) {
	}

	@media (max-width: 40rem) {
		.effect__fade.left {
			transform: translateX(-1.5rem);
		}

		.effect__fade.right {
			transform: translateX(1.5rem);
		}
	}
</style>
